export const ADMIN_UNREAD_EVENT = "lotq-admin-unread-summary-updated";

export function emitAdminUnreadSummary(summary) {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(ADMIN_UNREAD_EVENT, {
      detail: summary || { counts: {}, total: 0, tracked_tabs: [] },
    }),
  );
}

